var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-themed"},[_c('div',{staticClass:"access-section slide-out-section py-6 mr-3 pl-1",class:{'pr-6' : _vm.showAside && _vm.$vuetify.breakpoint.width > 1259}},[_c('hb-data-table',{attrs:{"headers":_vm.headers,"items":_vm.paymentCycles,"loading":_vm.loading}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }